<template>
  <div class="bs-wrapper auth-box">正在进入……</div>
</template>

<script>
import { routes } from '@/router';
import * as types from '@/store/mutation-types';
// import api from '@/api';

export default {
  name: 'Auth',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.getUserInfo();
  },

  destroyed() {},

  methods: {
    getUserInfo() {
      /**
       * 对于404处理
       */
      const { module } = this.$route.params;
      if (!routes.map(item => item.name).includes(module))
        return this.$router.replace({ name: 'not-found' });

      // const authWhiteList = routes.filter(item => item.authWhite);

      const { baseParams, payloadParams } = this.getUrlParams();

      /**
       * 对于无token处理
       * @type {string|*|string}
       */
      const token = baseParams.token;
      if (!token) return this.$router.replace({ name: 'no-power' });

      /**
       * 获取用户信息并存储
       */

      if (this.saveAccountStore(baseParams)) {
        const query = this.$route.query;
        delete query.base;
        localStorage.setItem('wxAuth', '1');
        console.log({ name: module, query: payloadParams });
        setTimeout(()=>{
          this.$router.replace({ name: module, query: payloadParams });
        },300)
      }

      // api
      //   .getUserInfo({
      //     queryUserId: baseParams.userId,
      //     storeId: baseParams.storeId,
      //   })
      //   .then(res => {
      //     if (this.saveAccountStore(res, baseParams)) {
      //       const query = this.$route.query;
      //       delete query.base;
      //       console.log(this.$store.state.account);
      //       payloadParams;
      //       this.$router.replace({ name: module, query: payloadParams });
      //     }
      //   })
      //   .catch(err => {
      //     this.$bsUtils.toast(err.message || '获取用户信息失败');
      //     this.$router.replace({ name: 'no-power' });
      //   });
    },
    /**
     * 存储用户信息
     * @param baseParams
     * @returns {Promise<boolean>}
     */
    async saveAccountStore(baseParams) {
      this.$store.commit('base/setBunkDesc', baseParams.bunkDesc);

      await this.$store.dispatch(
        `account/${types.ACCOUNT_TOKEN}`,
        baseParams.token
      );
  
      await this.$store.dispatch(
        `account/${types.ACCOUNT_USER_ID}`,
        baseParams.userId
      );
      
      await this.$store.dispatch(
        `account/${types.ACCOUNT_NAME}`,
        baseParams.name
      );
      await this.$store.dispatch(
        `account/${types.ACCOUNT_PLAZA_NAME}`,
        baseParams.plazaName || ''
      );
      await this.$store.dispatch(
        `account/${types.ACCOUNT_PLAZA_ID}`,
        baseParams.plazaId || ''
      );
      await this.$store.dispatch(
        `account/${types.ACCOUNT_TENANT_ID}`,
        baseParams.tenantId
      );
      await this.$store.dispatch(
        `account/${types.ACCOUNT_ROLE_TYPE}`,
        baseParams.roleType
      );
      await this.$store.dispatch(
        `account/${types.ACCOUNT_STORE_ID}`,
        baseParams.storeId || ''
      );
      await this.$store.dispatch(
        `base/${types.BASE_STORE_NAME}`,
        baseParams.storeName || ''
      );

      await this.$store.dispatch(
        `account/${types.ACCOUNT_MOBILE}`,
        baseParams.mobile
      );

      localStorage.setItem(
        'account',
        JSON.stringify(this.$store.state.account)
      );

      localStorage.setItem('token', baseParams.token);

      return true;
    },
    getUrlParams() {
      function getEmptyBase() {
        return {
          token: '',
          userId: '',
          storeId: '',
        };
      }

      function getDecode(params) {
        return JSON.parse(decodeURIComponent(params));
        // return JSON.parse(eval('(' + decodeURIComponent(params) + ')'));
      }

      const baseParams = this.$route.query.base
        ? getDecode(this.$route.query.base)
        : getEmptyBase();

      const payloadParams = this.$route.query.payload
        ? getDecode(this.$route.query.payload)
        : {};
      for (let key in payloadParams) {
        payloadParams[key] = payloadParams[key].toString();
      }
      return {
        baseParams,
        payloadParams,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.sh-button {
  margin: 20px;
}
</style>

